export const setInventories = (inventories) => ({
  type: "SET_INVENTORY",
  payload: inventories,
});

export const setCollection = (collection) => ({
  type: "SET_COLLECTION",
  payload: collection,
});
